<template>
    <div class="tabbar-content">
        <div class="tabbar">
            <div class="item" :class="{ 'act': actIdx == 2 }" @click.stop="change(2)">
                <van-icon name="apps-o" />
                <div class="item-text">{{ $t("tabbar.menu") }}</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 1 }" @click.stop="change(1)">
                <van-icon name="wap-home-o" />
                <div class="item-text">{{ $t("tabbar.Lobby") }}</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 3 }" @click.stop="change(3)">
                <!-- <van-icon name="friends-o" /> -->
                 <img class="affiliate" src="@/assets/common/invite.gif">
                <div class="item-text">{{ $t("tabbar.Affiliate") }}</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 4 }" @click.stop="change(4)">
                <van-icon name="diamond-o" />
                <div class="item-text">VIP</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 5 }" @click.stop="change(5)">
                <van-icon name="contact-o" />
                <div class="item-text">{{ $t("tabbar.Account") }}</div>
            </div>
        </div>
        <!-- <div v-if="isShowSaveVersion" class="pwa" @click="onShowSaveVersionPopup">
            <div class="iconfont icon-jiahao"></div>
            <div class="txt">{{ $t('downApp.SaveVersionDesktop') }}</div>
            <div class="iconfont icon-s-cuowu-guanbi" @click.stop="onCloseSaveVersion"></div>
        </div> -->
        <pwaIosPopup ref="pwaIosPopup" :isToHome="false"></pwaIosPopup>
        <SaveVersionPopup ref="SaveVersionPopup" :isToHome="false"></SaveVersionPopup>
        <div style="height: 1.24rem"></div>
    </div>
</template>

<script>
import pwaIosPopup from '@/views/downAppPWA/modules/pwaIosPopup'
import SaveVersionPopup from '@/views/downAppPWA/modules/SaveVersionPopup'
import { isPWA, getPlatform } from '@/utils'
export default {
    name: 'Tabbar',
    components: { pwaIosPopup, SaveVersionPopup },
    data() {
        return {
            actIdx: 1,
            isSaveVersionDesktop: true
        }
    },
    computed: {
        isShowSaveVersion() {
            return this.$store.state.system.isSaveVersionDesktop === 1 && this.isSaveVersionDesktop && (!isPWA()) && getPlatform() !== 'android' && getPlatform() !== 'Android'
        }
    },
    created() {
        const path = this.$route.path
        if (path === '/Home') {
            this.actIdx = 1
        }
        if (path === '/Affiliate') {
            this.actIdx = 3
        }
        if (path === '/vip') {
            this.actIdx = 4
        }
        if (path === '/Person') {
            this.actIdx = 5
        }
    },
    watch: {
        $route: {
            handler: function (to, from) {
                const path = this.$route.path
                if (path === '/Home') {
                    this.actIdx = 1
                } else if (path === '/Affiliate') {
                    this.actIdx = 3
                } else if (path === '/vip') {
                    this.actIdx = 4
                } else if (path === '/Person') {
                    this.actIdx = 5
                } else {
                    this.actIdx = -1
                }
            },
            deep: true
        }
    },
    methods: {
        change(idx) {
            if (this.actIdx === idx) return
            if (idx === 1) {
                this.onNavTo({ url: '/Home', replace: 1 })
                this.actIdx = idx
            } else if (idx === 2) {
                this.$store.dispatch('app/toggleSideBar')
            } else if (idx === 3) {
                this.onNavTo({ url: '/Affiliate', replace: 1 })
                this.actIdx = idx
            } else if (idx === 4) {
                this.onNavToByIsLogin({ url: '/vip', replace: 1 }).then(() => {
                    this.actIdx = idx
                })
            } else if (idx === 5) {
                this.onNavToByIsLogin({ url: '/Person', replace: 1 }).then(() => {
                    this.actIdx = idx
                })
            }
        },
        onCloseSaveVersion() {
            this.isSaveVersionDesktop = false
        },
        onShowSaveVersionPopup() {
            this.isSaveVersionDesktop = false
            if (getPlatform() === 'ios') {
                this.$refs.pwaIosPopup.open()
            } else {
                this.$refs.SaveVersionPopup.open()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
$bg-tabbar-color: #2b1508;

html[data-device-nodesktop="0"] {
    .tabbar {
        max-width: 100%;
    }

    .tabbar-content {
        max-width: 100%;
    }
}

.tabbar-content {
    position: relative;

    .pwa {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: .62rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: rgba(255, 255, 255, 0.8);
        padding: 0 .26rem;
        color: #f5d888;
        font-size: .34rem;
        z-index: 101;
        line-height: .34rem;
    }
}

.tabbar {
    position: fixed;
    bottom: 0;
    z-index: 100;
    // position: relative;
    margin: 0 auto;
    height: 1.24rem;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(180deg, #4a1d05 0%, #281105 54%, #120b06 100%);
    border-top: 1px solid rgba(255, 138, 0, .34);
    // filter: drop-shadow(0 -4px 10px rgba(0, 0, 0, .3));
    // box-shadow: 0rpx -6rpx 13rpx 0rpx rgba(202,255,207,.22);

    .item {
        width: 20%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        overflow: visible;
        position: relative;
        cursor: pointer;
        padding-top: 0.08rem;
        padding-bottom: .2rem;

        ::v-deep .van-icon{
            font-size: .48rem;
            color: #b9a89c;
        }

        .affiliate {
            height: 1rem;
            width: auto;
            filter: drop-shadow(rgb(255, 255, 255) 0px 0px 5px);
            margin-bottom: -.1rem;
        }

        .item-text {
            height: .24rem;
            line-height: .24rem;
            width: 100%;
            text-align: center;
            font-size: .24rem;
            color: #b9a89c;
            margin-top: .08rem;
            position: relative;
            z-index: 9;
        }

        &.act {
            ::v-deep .van-icon{
                color: #ff9b2f;
            }
            .item-text {
                color: #ff9b2f;
            }

            &.center {
                .center-img {
                    .center-inset {
                        border: 1px solid rgba(255, 173, 66, .55);
                        background: linear-gradient(180deg, #ffad42 0%, #ff7300 100%);
                    }
                }
            }
        }

        &.center {
            position: relative;

            .center-img {
                position: absolute;
                width: 1.2rem;
                height: 1.2rem;
                background: #2b1508;
                border-radius: 50%;
                top: -12px;
                display: flex;
                align-items: center;
                justify-content: center;
                left: calc(50% - .6rem);

                .center-inset {
                    border: 1px solid rgba(255, 138, 0, .65);
                    border-radius: 50%;
                    width: .95rem;
                    height: .95rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: linear-gradient(180deg, rgba(255, 173, 66, .24), rgba(230, 81, 0, .58) 77%);
                    padding-bottom: .05rem;
                }
            }
        }
    }
}
</style>
